import { put } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
export default function * failure ({ error }) {
  if (error && error.message && error.message === 'No User') { yield put(UserActions.logout()) } else { 
    // console.log(error) 
  }
}
